/**
 * useConflictDetection — listens for sync conflicts from the offline queue
 * and shows user-facing toast warnings.
 *
 * A conflict occurs when:
 * - A queued write is replayed against the server
 * - The server responds with 409 or the handler detects updated_at drift
 * - The handler throws ConflictError
 *
 * The user sees: "Daten wurden zwischenzeitlich geaendert" with the entry type.
 */

import { useEffect } from 'react'
import { onConflict, type ConflictEvent } from '@appic/lib'
import { toast } from './use-toast'

const TYPE_LABELS: Record<string, string> = {
  'appointment:create': 'Termin',
  'appointment:cancel': 'Termin-Löschung',
  'visit-report:submit': 'Besuchsbericht',
}

export function useConflictDetection() {
  useEffect(() => {
    return onConflict((event: ConflictEvent) => {
      const label = TYPE_LABELS[event.entry.type] || event.entry.type
      toast({
        variant: 'warn',
        title: 'Daten wurden zwischenzeitlich geändert',
        description: `${label}: Serverdaten sind neuer als Ihre lokale Version. Bitte prüfen und ggf. erneut eingeben.`,
      })
    })
  }, [])
}
